import { ComponentType, Fragment, ReactNode, useCallback } from 'react';

import { useAuth } from '@sbv-clients/shared-feature-auth';

import { DepartmentFilter } from './departmentFilter';
import { FacilityFilter } from './facilityFilter';

type UseApiParamsReturnType = { facilityId?: number; departmentId: number };

const useApiParams = (props: {
  useContextFn: () => {
    facilityId: number;
    departmentId?: number;
  };
}) => {
  const { isMultiFacility } = useAuth();
  const { facilityId, departmentId } = props.useContextFn();
  const getParams = useCallback(() => {
    if (isMultiFacility) {
      return { facilityId, departmentId } as UseApiParamsReturnType;
    }
    return { departmentId } as UseApiParamsReturnType;
  }, [departmentId, facilityId, isMultiFacility]);
  return { getParams };
};

export const FacilitiesAndDepartmentsFilter = (props: {
  withFacilityAllOption?: boolean;
  departmentWithAllOption?: boolean;
  useContextFn: () => {
    facilityId?: number;
    setFacilityId: (value: number) => void;
    departmentId?: number;
    setDepartmentId: (value: number) => void;
  };
  filteredByOpeningTemplates?: boolean;
  FieldWrapper?: ComponentType<{ children: ReactNode }>;
}) => {
  const { isMultiFacility } = useAuth();
  const FieldWrapper = props.FieldWrapper ?? Fragment;
  return (
    <>
      {isMultiFacility && (
        <FieldWrapper>
          <FacilityFilter
            useContextFn={props.useContextFn}
            autoSelectIfEmpty
            withAllOption={props.withFacilityAllOption ?? false}
            filteredByOpeningTemplates={props.filteredByOpeningTemplates}
          />
        </FieldWrapper>
      )}
      <FieldWrapper>
        <DepartmentFilter
          useContextFn={props.useContextFn}
          autoSelectIfEmpty
          withAllOption={props.departmentWithAllOption ?? false}
          filteredByOpeningTemplates={props.filteredByOpeningTemplates}
        />
      </FieldWrapper>
    </>
  );
};

FacilitiesAndDepartmentsFilter.useMultiFacilityApiBodyParams = useApiParams;

export default FacilitiesAndDepartmentsFilter;
